import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';

import MobilePhone from '@mui/icons-material/Smartphone';

import HeaderBar from '../components/HeaderBar';
import positive from '../components/positive.png';
import uncertain from '../components/uncertain.png';
import negative from '../components/negative.png';
import withRouter from '../utils/withRouter';

const PhoneIcon = styled(MobilePhone)(({ theme }) => ({
	marginLeft: theme.spacing(2)
}));

const ImageButton = styled('img')(({ theme }) => ({
	width: theme.spacing(9),
	height: theme.spacing(9),
}));

const ButtonLabel = styled('div')({
	textAlign: "center"
});

const GridContainer = styled('div')(({ theme }) => ({
	padding: theme.spacing(1),
	marginTop: theme.spacing(-4),
	[theme.breakpoints.up('sm')]: {
		paddingTop: theme.spacing(1),
		marginTop: 0
	},
	[theme.breakpoints.up('lg')]: {
		marginTop: theme.spacing(-2.5)
	},
}));

const ScreenLabel = styled(Typography)(({ theme }) => ({
	[theme.breakpoints.up('lg')]: {
		marginBottom: theme.spacing(1),
	},
	[theme.breakpoints.up('sm')]: {
		marginBottom: theme.spacing(3)
	},
}));

const ContactContainer = styled('div')(({ theme }) => ({
	marginTop: theme.spacing(8),
	[theme.breakpoints.up('lg')]: {
		marginTop: theme.spacing(2)
	},
	[theme.breakpoints.up('md')]: {
		marginTop: theme.spacing(6)
	},
	[theme.breakpoints.up('sm')]: {
		marginTop: theme.spacing(8)
	},
	// Escape hatch for overly short desktop window
	'@media (max-height: 650px)': {
		marginTop: theme.spacing(2)
	}
}));

const SkiaTypography = styled(Typography)(({ theme }) => ({
	fontFamily: 'Montserrat, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
	fontSize: theme.spacing(3),
	fontWeight: 900
}));

class CategorizeTips extends Component {

	onCloseTap = () => {
		const {messageSource} = this.props;
		if(messageSource) {
			messageSource.postMessage({
				type: "APP_CONTROL",
				action: "close"
			}, "*");
		} else if(this.props.history.length > 0) {
			this.props.history.goBack();
		} else {
			window.history.back();
		}
	}

	render() {
		let {isMobile, locationContact, recaptchaRef} = this.props;
		let {areaCode, prefix, lineNum} = locationContact ? {
			areaCode: locationContact.slice(1, 4), 
			prefix: locationContact.slice(4, 7), 
			lineNum: locationContact.slice(7, 11)
		} : {};

		return (
			<div>
				<HeaderBar 
					category="transparent"
					closeHandler={this.onCloseTap}
					recaptchaRef={recaptchaRef}
					recaptchaHandler={token => {}}
				/>
				<GridContainer>
					<Grid container direction="column" alignItems="center" spacing={2}>
						<Grid item>
							<ScreenLabel variant="h5">Share Something ...</ScreenLabel>
						</Grid>
						<Grid item>
							<ButtonLabel>
								<Link className="primary" to="/share/positive/">
									<Button
										color="primary"
										aria-label="Good"
										ga-on="click"
										ga-event-category="WebApp"
										ga-event-action="Button Pressed"
										ga-event-label="Open Positive Form">
										<ImageButton src={positive} alt="smile" />
									</Button>
								</Link>
								<SkiaTypography variant="h5">Good</SkiaTypography>
							</ButtonLabel>
						</Grid>
						<Grid item>
							<ButtonLabel>
								<Link className="primary" to="/share/uncertain/">
									<Button
										color="primary"
										aria-label="Sad"
										ga-on="click"
										ga-event-category="WebApp"
										ga-event-action="Button Pressed"
										ga-event-label="Open Neutral Form">
										<ImageButton src={uncertain} alt="glum" />
									</Button>
								</Link>
								<SkiaTypography variant="h5">Sad</SkiaTypography>
							</ButtonLabel>
						</Grid>
						<Grid item>
							<ButtonLabel>
								<Link className="primary" to="/share/negative/">
									<Button
										color="primary"
										aria-label="Bad"
										ga-on="click"
										ga-event-category="WebApp"
										ga-event-action="Button Pressed"
										ga-event-label="Open Negative Form">
										<ImageButton src={negative} alt="frown" />
									</Button>
								</Link>
								<SkiaTypography variant="h5">Bad</SkiaTypography>
							</ButtonLabel>
						</Grid>
						<Grid item>
							<ContactContainer>
								{
									locationContact ? 
										isMobile ? 
											(<Button 
												aria-label="Talk with someone"
												ga-on="click"
												ga-event-category="WebApp"
												ga-event-action="Button Pressed"
												ga-event-label="Call Someone"
												href={`tel:${locationContact}`}
												>
												Talk with someone <PhoneIcon />
											</Button>)
										: 
											(<Grid container direction="column" alignItems="center">
												<Grid item>
													<Typography variant="subtitle1">Talk with someone</Typography>
												</Grid>
												<Grid item>
													<Typography variant="subtitle1">1-{areaCode}-{prefix}-{lineNum}</Typography>
												</Grid>
											</Grid>)
									: null 
								}
							</ContactContainer>
						</Grid>
					</Grid>
				</GridContainer>
			</div>
		);
	}
}

CategorizeTips.propTypes = {
	messageSource: PropTypes.object,
	locationContact: PropTypes.string,
	isMobile: PropTypes.bool,
	recaptchaRef: PropTypes.object,
	history: PropTypes.object.isRequired
};

export default withRouter(CategorizeTips);